import AmplitudeHelper from "utils/analytics";

export const NOTIF_ENTRY_POINT = {
  DROPDOWN: "dropdown",
  PAGE: "page",
};

export const logNotifCenterOpened = () => {
  AmplitudeHelper.logEvent("notif_center_opened");
};

export const logNotifListViewed = () => {
  AmplitudeHelper.logEvent("notif_list_viewed");
};

export const logNotificationClick = ({ entryPoint, notificationType, statusBefore }) => {
  AmplitudeHelper.logEvent("notif_clicked", {
    entry_point: entryPoint,
    notification_type: notificationType,
    status_before: statusBefore,
  });
};
